import { createSelector } from '@reduxjs/toolkit';
import { getIsHubless } from '../reducers/Portal';
import { selectNavExtensionTriggers } from '../selectors';

// TODO: Remove the isHubless check once we determine how to pass it using Quartz template
export const selectIsCopilotEnabled = createSelector([selectNavExtensionTriggers, getIsHubless], (navExtensionTriggers, isHubless) => {
  var _navExtensionTriggers;
  return !isHubless && (navExtensionTriggers === null || navExtensionTriggers === void 0 || (_navExtensionTriggers = navExtensionTriggers.copilot) === null || _navExtensionTriggers === void 0 ? void 0 : _navExtensionTriggers.isEnabled);
});